const reducerRegister = (state, action) => {
  const key = action?.key ?? "id";

  if (action.type === "LOAD") {
    return [...action?.payload];
  }

  if (action.type === "ADD") {
    const newItem = action.payload;
    state.push(newItem);
  }

  if (action.type === "UPDATE") {
    const index = state?.findIndex((e) => e?.[key] === action?.payload?.[key]);
    if (index !== -1) state[index] = action?.payload;
  }

  if (action.type === "DELETE") {
    const index = state?.findIndex((e) => e?.[key] === action?.payload?.[key]);
    if (index !== -1) state?.splice(index, 1);
  }

  return [...state];
};

export { reducerRegister };
